module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isManager('project|finance|maintenance|admin|management')) ? _c('popup', {
    attrs: {
      "button-style": "info",
      "heading": "Add Equipment",
      "show-text": _vm.showText,
      "button-size": _vm.buttonSize,
      "button-text": "Add",
      "button-icon": "fa fa-cogs",
      "disable-save": false,
      "disable-button": !_vm.isManager('project|finance|maintenance|admin|management') || _vm.readOnly
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "Note!",
      "description": "You can add equipment for any telco, not just the site sharers. If you need a new sharer, you must add that on the Sharer page.",
      "closable": false,
      "show-icon": ""
    }
  })], 1)], 1), _vm._v(" "), _c('equip-details', {
    ref: "ad",
    attrs: {
      "owner-id": _vm.ownerId,
      "site-id": _vm.siteId,
      "editMode": true,
      "adding": true,
      "hide-panel": true,
      "table-ref": _vm.tableRef
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c81d60f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/EquipAction.vue
// module id = 1470
// module chunks = 0